class CartRemoveButton extends HTMLElement {
  constructor() {
    super();


    this.addEventListener('click', async (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      var lineItems = {};
      let type = 'normal';
      let packId = null;
      if (this.closest('.cart-item').dataset.type == "parent") {
        packId = this.closest('.cart-item').dataset.pack;
        lineItems[this.closest('.cart-item').dataset.key] = 0;
        cartItems.querySelectorAll('.cart-item[data-pack="' + packId + '"]').forEach(child => {
          if (child.getAttribute('data-type') != 'parent') {
            lineItems[child.getAttribute('data-key')] = 0;
          }
        })
        type = 'packs';
      }
      if(this.classList.contains("gift-note-remove")){
        var removeEl = document.querySelectorAll(".gift-note__button--remove");
          if(removeEl){
            removeEl.forEach(el => {
            el.click();
            });
          }
      }
      
      cartItems.updateQuantity(this.dataset.index, 0, null , lineItems, type, packId);

      setTimeout(() => {
        
        fetch(window.Shopify.routes.root + 'cart.js')
        .then((response) => response.json())
        .then((cart) => {
          const giftProductExists = cart.items.some((item) => item.properties._gift_product === true);
          console.log('giftProductExists', giftProductExists)
          const giftCheckbox = document.getElementById("giftCheckbox");
          giftCheckbox.checked = giftProductExists;
        })
        .catch((error) => console.error('Error:', error));
      }, 250)
    });
  }
}
customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement = document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');
    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener('change', debouncedOnChange.bind(this));
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'cart-items') {
        return;
      }
      this.onCartUpdate();
    });
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  onChange(event) {
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'));
  }

  onCartUpdate() {
    fetch(`${routes.cart_url}?section_id=main-cart-items`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const sourceQty = html.querySelector('cart-items');
          this.innerHTML = sourceQty.innerHTML;
        })
        .catch(e => {
          console.error(e);
        });
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section'
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents'
      }
    ];
  }

  updateQuantity(line, quantity, name = null, lines = null, type = 'normal', packId = null) {
    calcPosition();
    let sections = this.getSectionsToRender().map((section) => section.section);
    if(window.location.pathname == '/cart') {
      sections = [document.getElementById('main-cart-items').dataset.id, 'cart-icon-bubble', 'cart-live-region-text', document.getElementById('main-cart-footer').dataset.id, "cart-drawer", "cart-icon-bubble"];
    }

    let URL = `${routes.cart_change_url}`;
    let body = JSON.stringify({
      line,
      quantity,
      sections: sections,
      sections_url: window.location.pathname
    });
    if(type == 'packs') {
      body = JSON.stringify({
        updates: lines,
        sections: this.getSectionsToRender().map((section) => section.section),
        sections_url: window.location.pathname
      });
      URL = `${routes.cart_update_url}`;
    }
    let overlay = document.getElementById('overlay');
    overlay.style.display = 'block';
    return fetch(URL, { ...fetchConfig(), ...{ body } })
        .then((response) => {
          return response.text();
        })
        .then(async (state) => {
          const parsedState = JSON.parse(state);
          if (parsedState.status) {
            showNotification(parsedState.description, 'error')
          }
          else {
            const quantityElement = document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
            var items = document.querySelectorAll('.cart-item');

            await renderPriceShipping(true, Number(parsedState.original_total_price) / 100);
            if(quantity == 0) {
              let isRemoveGift = true;
              let preorder = false;
              parsedState.items.forEach(item => {
                if(item.id == giftVariantId) {
                  isRemoveGift = false;
                }
                if(item.properties["preorder"]){
                  preorder = true;
                }
              })
              if(isRemoveGift == true) {
                let dataGif = {"attributes": {"gift-from": "", "gift-to": "", "gift-note": ""}};
                await updateJson(dataGif);
              }
              var dataPreorder = null;
              if(preorder){
                dataPreorder = {"attributes": {"preorder": "Yes"}};
              }else{
                dataPreorder = {"attributes": {"preorder": ""}};
              }
              await updateJson(dataPreorder);
            }

            if (parsedState.errors) {
              quantityElement.value = quantityElement.getAttribute('value');
              this.updateLiveRegions(line, parsedState.errors);
              return;
            }

            this.classList.toggle('is-empty', parsedState.item_count === 0);
            const cartDrawerWrapper = document.querySelector('cart-drawer');
            const cartFooter = document.getElementById('main-cart-footer');

            if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
            if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);


            let sections = this.getSectionsToRender();
            if(window.location.pathname == '/cart') {
              if(type == 'packs') {
                let itemsPacks = document.querySelectorAll('[data-pack="'+packId+'"]')
                if(itemsPacks.length > 0) {
                  for(let i=0; i< itemsPacks.length; i++) {
                    itemsPacks[i].remove();
                  }
                }
              }
              if(document.getElementById('main-cart-items')) {
                sections.push({id: 'main-cart-items', section: document.getElementById('main-cart-items').dataset.id, selector: '.js-contents'})
              }
              if(document.getElementById('main-cart-footer')) {
                sections.push({id: 'main-cart-footer', section: document.getElementById('main-cart-footer').dataset.id, selector: '.js-contents'})
              }
              if(document.getElementById('cart-icon-bubble')) {
                sections.push({id: 'cart-icon-bubble', section: 'cart-icon-bubble', selector: '.shopify-section'})
              }
              if(document.getElementById('cart-live-region-text')) {
                sections.push({id: 'cart-live-region-text', section: 'cart-live-region-text', selector: '.shopify-section'})
              }
              if(document.getElementById('CartDrawer')) {
                sections.push({id: "CartDrawer", section : "cart-drawer", selector: ".drawer__inner"})
              }
            }

            sections.forEach((section => {
              if(parsedState.sections[section.section]) {
                const elementToReplace =
                    document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
                elementToReplace.innerHTML =
                    this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
              }
            }));
            const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
            let message = '';
            if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
              if (typeof updatedValue === 'undefined') {
                message = window.cartStrings.error;
              } else {
                message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
              }
            }
            this.updateLiveRegions(line, message);

            const lineItem = document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
            if(parsedState.item_count === 0 && window.location.pathname == '/cart'){
              var cartWrapper = document.querySelector(".main-cart-page");
              if(!cartWrapper.classList.contains("is-empty")){
                cartWrapper.classList.add("is-empty")
              }
              var estimateShippingEl = document.querySelector(".estimate-shipping");
              var giftSection = document.querySelector(".gift-note__wrap");
              estimateShippingEl.classList.add("!tw-hidden");
              giftSection.classList.add("!tw-hidden");
              var anotherSection = document.querySelectorAll(".shopify-section.section");
              document.getElementsByTagName("body")[0].style.background = "white";
              var mainContentEl = document.getElementById("MainContent");
              mainContentEl.classList.add("!tw-block");
              mainContentEl.style.maxWidth = "none";
              mainContentEl.style = "25px 0 30px 0";
              if(anotherSection){
                anotherSection.forEach(el => {
                  el.style.display = "block";
                })
              }
            }
            if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
              cartDrawerWrapper ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`)) : lineItem.querySelector(`[name="${name}"]`).focus();
            } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
              trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'))
            } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
              trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'))
            }
            changeQtyMiniCart();
            publish(PUB_SUB_EVENTS.cartUpdate, {source: 'cart-items'});
          }

        })
    .catch(() => {
      this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
      const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
      errors.textContent = window.cartStrings.error;
    })
    .finally(async () => {
      sortPack('last');
            await renderKlarnaservices()
      overlay.style.display = 'none';
      renderDataGift();
      renderETShipping();
      showPriceSale();
    });
  }

  updateLiveRegions(line, message) {
    const lineItemError = document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) lineItemError.querySelector('.cart-item__error-text').innerHTML = message;

    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus = document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-overlay`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-overlay`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`);

    cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define('cart-note', class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
      }, ON_CHANGE_DEBOUNCE_TIMER))
    }
  });
};
  